/*
 *
 * OrderSummary reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  SET_CHECKOUT_SUCCESS,
  GET_ORDER_DETAIL,
  FETCH_PAY_BALANCE_SUCCESS,
  SET_CASHFREE_POPUP,
  SET_GENERATE_OTP,
  SET_CONFIRM_OTP,
} from './constants';

const initialState = fromJS({ paymentDetails: {}, order: {}, zscs: [], zaggle_cash: 0, isLoading: false, cashfreePopUp: { status: false }, generateOtp: { status: false }, confirmOtp: { status: false } });

function orderSummaryReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case SET_CHECKOUT_SUCCESS:
      return state
        .set('paymentDetails', fromJS(payload))
        .set('isLoading', false);
    case GET_ORDER_DETAIL:
      return state
        .set('order', fromJS(payload.order))
        .set('isLoading', false);
    case FETCH_PAY_BALANCE_SUCCESS: {
      const { zscs, zaggle_cash } = payload;
      return state
        .set('zaggle_cash', fromJS(zaggle_cash))
        .set('zscs', fromJS(zscs))
        .set('isLoading', false);
    }
    case SET_CASHFREE_POPUP:
      return state
        .set('cashfreePopUp', fromJS(payload))
        .set('isLoading', false);
    case SET_GENERATE_OTP:
      return state
        .set('generateOtp', fromJS(payload))
        .set('isLoading', false);
    case SET_CONFIRM_OTP:
      return state
        .set('confirmOtp', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default orderSummaryReducer;



// WEBPACK FOOTER //
// client/containers/OrderSummary/reducer.js